
import { Card } from "@/components/ui/card";

interface Review {
  id: string;
  created_at: string;
  rating: number;
  comment?: string;
  user?: {
    first_name?: string;
    last_name?: string;
  };
  meal?: {
    name?: string;
    chef_id?: string;
  };
}

interface ReviewsListProps {
  reviews: Review[];
}

export const ReviewsList = ({ reviews }: ReviewsListProps) => {
  return (
    <div>
      <h2 className="text-xl font-semibold mb-4 text-black">Reviews</h2>
      {reviews.length === 0 ? (
        <p className="text-gray-500">No reviews yet</p>
      ) : (
        <div className="space-y-4">
          {reviews.map((review) => (
            <Card key={review.id} className="p-4">
              <div className="flex justify-between items-start">
                <div>
                  <p className="font-medium text-black">
                    {review.user?.first_name} {review.user?.last_name}
                  </p>
                  <p className="text-sm text-gray-500">
                    {new Date(review.created_at).toLocaleDateString()}
                  </p>
                  <p className="text-sm text-primary mt-1">
                    Ordered: {review.meal?.name}
                  </p>
                </div>
                <div className="text-yellow-400">
                  {review.rating} ★
                </div>
              </div>
              {review.comment && (
                <p className="mt-2 text-black">{review.comment}</p>
              )}
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};
